import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import {
  AppState,
  isFirstUserAccess,
  isUserAuthenticated,
} from '@app/store/store.states';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { AUTH_ROUTE_NAMES } from '@app/modules/auth/auth.routes.names';
import { combineLatest } from 'rxjs';
import { PORTAL_ROUTE_NAMES } from '@app/modules/portal/portal.routes.names';

@Injectable({ providedIn: 'root' })
export class ExternalRoutesGuard implements CanActivate {
  constructor(private readonly store: Store<AppState>, private readonly router: Router) {}

  canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    const isFirstUserAccessProcessRoute =
      activatedRouteSnapshot.firstChild.data.firstUserAccessProcessRoute || false;

    return combineLatest([
      this.store.select(isUserAuthenticated),
      this.store.select(isFirstUserAccess),
    ]).pipe(
      map(([isAuthenticated, firstAccess]) => {
        if (isAuthenticated && !firstAccess) {
          return this.handleActivatedUserAccess();
        }

        if (isFirstUserAccessProcessRoute && !firstAccess) {
          this.redirectUserToInitialFirstAccessStepPage();
          return false;
        }

        return true;
      })
    );
  }

  redirectUserToInitialFirstAccessStepPage() {
    this.router.navigateByUrl(AUTH_ROUTE_NAMES.ACTIVATE_ACCOUNT);
  }

  handleActivatedUserAccess() {
    this.router.navigateByUrl(PORTAL_ROUTE_NAMES.DASHBOARD);
    return false;
  }
}
